<template>
  <v-app>
    <Navigation />
    <v-main class="primary" color="#181818">
      <transition name="slide-fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

export default {
  name: 'App',
  data() {
    return {}
  },

  components: {
    Navigation,
  },
}
</script>

<style>
@font-face {
    font-family: "BlockLetterz";
    src: url("./assets/101BlockLetterz-XZYK.ttf");
}
@font-face {
    font-family: "NIPPONBL";
    src: url("./assets/NIPPONBL.TTF");
}
@font-face {
    font-family: "mars";
    src: url("./assets/MarsWeltfremd-vKJZ.ttf");
}
@font-face {
    font-family: "origami";
    src: url("./assets/origa___.ttf");
}
@font-face {
    font-family: "esquare";
    src: url("./assets/E-SQUARE_demo.otf");
}

/* p {
  font-family: esquare;
  font-size: 1em;
  color: #FFFFFF;
  font-variant: small-caps;
} */

h2 {
  font-family: esquare;
  font-size: 2em;
  color: #FFFFFF;
  font-variant: small-caps;
}

h3 {
  font-family: esquare;
  font-size: 1.5em;
  color: #FFFFFF;
  font-variant: small-caps;
}

.period {
  font-family: helvetica;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.5s ease-out;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
</style>